export const TiposGestion = [
    "SURA",
    "EMPRESA"
];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/TiposGestion.ts